import { BoxPart } from "./BoxPart";

export class BoxFloor extends BoxPart{
    public getCopy(): BoxFloor {
        const parentCopy = super.getCopy();
        const trueCopy = new BoxFloor(parentCopy.getObject(),parentCopy.getHitbox(), this.name);
        trueCopy.setVisible(this.getObject().visible);
        return trueCopy;
    }
}